// translations/pages/events/it.js
// Labels of the events section and page, and the texts of every event by its id
// from config/events.cjs. Dates are not written here; the pages format them.

export const eventsPageIT = {
  title: 'Eventi',
  upcoming: 'Prossimi eventi',
  past: 'Eventi passati',
  all: 'Tutti gli eventi',
  items: {
    wikki26: {
      title: 'WiKKI26 – Conferenza di Wildau sull’intelligenza artificiale',
      description: 'pAIoneer Labs era presente come espositore alla Technische Hochschule Wildau. Allo stand si è parlato di come si realizzano infrastrutture di IA locali in aziende e organizzazioni: sovranità dei dati, protezione dei dati fin dalla progettazione e IA a norma di legge, senza inutili dipendenze da soluzioni cloud esterne.'
    }
  }
};
